import React, { useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import "./headerFooter.scss";
import blackLogo from "../Assets/Images/zenceBlackLogo.svg";
import whiteLogo from "../Assets/Images/Zencelogo.svg";
import xTwitter from "../Assets/Images/x-twitter.svg";
import instagram from "../Assets/Images/square-instagram.svg";
import youtube from "../Assets/Images/youtube.svg";

export default function Footer(props) {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="footer-container">
          <div className="row">
            <div className="col">
              <div className="footer-logo">
                <NavLink className="nav-link" to="/">
                  <img src={whiteLogo} alt="Logo" className="logo" />
                </NavLink>
              </div>
            </div>
            <div className="col">
              <h4 className="footer-heading">Contact us at</h4>
              <ul className="list-unstyled">
                <li>
                  <a className="nav-link" href="tel:7428846111">
                  +91-74288 46111
                  </a>
                </li>
                <li>
                <a className="nav-link" href="mailto:inquiries@zencecrm.com">
                inquiries@zencecrm.com
                  </a>
                </li>
               
              </ul>
            </div>
           
          
            <div className="col-lg-2">
            <h4 className="footer-heading">Follow us on</h4>
              <ul className="list-inline d-flex gap-3 mb-0">
                <li>
                  <a href="https://www.facebook.com/zencecrm/" target={`_blank`}>
                    <span className="social-bubble">
                      <i className="fa fa-facebook"></i>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/ZenceCRM/" target={`_blank`}>
                    <span className="social-bubble">
                      <img src={xTwitter} alt="twitter" />
                    </span>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/zencecrm/" target={`_blank`}>
                    <span className="social-bubble">
                      <img src={instagram} alt="twitter" />
                    </span>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/zence-unifiedcrm/" target={`_blank`}>
                    <span className="social-bubble">
                    <i className="fa fa-linkedin" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid border-top">
        <div className="bottom-footer">
          <div className="row justify-content-between align-items-center">
            
            <div className="col-lg-12">
              <p className="mb-0 text-center">
                © {new Date().getFullYear()} onwards. All Rights Reserved.
                Easyrewardz Software Services Private Limited | <a href="#">Privacy Policy</a>
              </p>
            </div>
            
          </div>
        </div>
      </div>
     
    </footer>
  );
}
